import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Paper, Typography, Link as MatLink } from "@material-ui/core";
import Link from "../components/Link";
import AgentChat from "../components/AgentChat";
import { navRoutes } from "../components/AdminAppBar";
import { useUser } from "../hooks/user";
import { Divider } from "@material-ui/core";
import config from "../config";

const PROD_ENVS = new Set(["production", "prod"]);

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    height: "calc(100vh - 80px)",
    padding: theme.spacing(2)
  },
  navSidebar: {
    width: 200,
    marginRight: theme.spacing(2),
    padding: theme.spacing(2)
  },
  chatContainer: {
    flex: 1,
    display: "flex"
  }
}));

export default function DashboardPage() {
  const classes = useStyles();
  const { user } = useUser();
  const isProduction = PROD_ENVS.has(config.appEnv);

  return (
    <Box className={classes.root}>
      <Paper className={classes.navSidebar}>
        <Typography variant="subtitle2" gutterBottom>
          Hello, {user.name}
        </Typography>
        <Typography variant="caption" color="textSecondary" gutterBottom>
          Quick Links
        </Typography>
        <ul style={{ paddingLeft: 16, margin: 0 }}>
          {navRoutes.map(([name, href]) => (
            <li key={name} style={{ marginBottom: 4 }}>
              <Link to={href}>{name}</Link>
            </li>
          ))}
          <li>
            <Link to="/boom-report">Boom Report</Link>
          </li>
          {!isProduction && (
            <li style={{ marginBottom: 4 }}>
              <Link to="/dev">Dev Tools</Link>
            </li>
          )}

          <Divider style={{ marginBottom: 16, marginTop: 16 }} />

          <li style={{ marginBottom: 4 }}>
            <MatLink href="/v2">Go to Admin V2</MatLink>
          </li>
        </ul>
      </Paper>
      <Box className={classes.chatContainer}>
        <AgentChat />
      </Box>
    </Box>
  );
}
